module.exports = __webpack_public_path__ + "img/footprint_team_spirit.7d64cef0.png";